/** Reset means restore the tool, never drop back to the browser's arrow. */
export const TOOL_CURSOR = 'var(--tool-cursor)';

export function canvasCursor(css: string | null): string {
  return !css || css === 'default' || css === 'auto' || css === 'crosshair' ? TOOL_CURSOR : css;
}

/** All canvas cursor writes share this path, including guides and tool teardown. */
export function setCanvasCursor(canvas: HTMLCanvasElement, css: string | null): void {
  const wanted = canvasCursor(css);
  if (canvas.style.cursor !== wanted) canvas.style.cursor = wanted;
}
